import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + '/api';

const getAuthHeader = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` }
});

export const getHPTs = async () => {
    const response = await axios.get(`${API_URL}/hpt`, getAuthHeader());
    return response.data;
};

export const getPTWs = async () => {
    const response = await axios.get(`${API_URL}/ptw`, getAuthHeader());
    return response.data;
};

export const getPTWStats = async () => {
    const response = await axios.get(`${API_URL}/ptw/stats/conteo-anual`, getAuthHeader());
    return response.data; // Retorna { total_anio: 200 }
};